import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, BookOpenIcon, StarIcon, GlobeIcon } from 'lucide-react';
export function Metrics() {
  const metrics = [{
    icon: <UsersIcon className="text-brand-DEFAULT" size={24} data-id="element-155" />,
    number: '+300',
    text: 'entrenadores confían'
  }, {
    icon: <BookOpenIcon className="text-brand-DEFAULT" size={24} data-id="element-156" />,
    number: '6+6',
    text: 'Tomos + Bonos'
  }, {
    icon: <StarIcon className="text-brand-gold fill-brand-gold" size={24} data-id="element-157" />,
    number: '4.9/5',
    text: 'calificación'
  }, {
    icon: <GlobeIcon className="text-brand-accent" size={24} data-id="element-158" />,
    number: 'Mundial',
    text: ''
  }];
  return <section className="border-y border-dark-border bg-dark-card py-8" data-id="element-159">
      <div className="max-w-6xl mx-auto px-4" data-id="element-160">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4" data-id="element-161">
          {metrics.map((metric, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center justify-center text-center space-y-2" data-id="element-162">
              <div className="p-3 bg-dark-DEFAULT rounded-full border border-dark-border" data-id="element-163">
                {metric.icon}
              </div>
              <span className={`font-bebas text-2xl md:text-3xl tracking-wide ${index === 3 ? 'text-brand-accent' : index === 1 ? 'text-brand-gold' : 'text-brand-DEFAULT'}`} data-id="element-164">
                {metric.number}
              </span>
              {metric.text && <span className="text-sm text-white" data-id="element-165">{metric.text}</span>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}